import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Amplify } from 'aws-amplify';
import { HelmetProvider } from '@osu/react-ui';

import createAppStore from './storeConfig';
import App from './App/containers';
import AppleTouchIcon from './DocumentHead/AppleTouchIcon';
import './styles/index.scss';
import 'normalize.css';
import { apiConfig, libraryOptions } from './api-config';
import { AlertBar } from './Common/components/AlertBar';
import RefreshPageAlert from "./Common/JavascriptVersionChecker";

Amplify.configure(apiConfig, libraryOptions);
console.log("id:", import.meta.env.VITE_API_ID)
const store = createAppStore();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter>
          <AppleTouchIcon />
          <AlertBar>
            <App darkMode={false} />
          </AlertBar>
        </BrowserRouter>
        <RefreshPageAlert />
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
